'use client';
import Link from 'next/link';

export default function Navbar() {
  return (
    <nav style={{
      background:'#0a0f1e',
      borderBottom:'1px solid #1a2744',
      padding:'0 40px',
      height:'64px',
      display:'flex',
      alignItems:'center',
      justifyContent:'space-between',
      position:'sticky',
      top:0,
      zIndex:100
    }}>
      <Link href="/" style={{textDecoration:'none'}}>
        <span style={{fontWeight:900,fontSize:'1.4rem',color:'#fff',fontFamily:'sans-serif'}}>
          MiRuta<span style={{color:'#f5a623'}}>USA</span>
        </span>
      </Link>

      <div style={{display:'flex',gap:'32px',alignItems:'center'}}>
        {['Inicio','Servicios','Empresas','Conductores','Contacto'].map(item => (
          <Link key={item} href="#" style={{
            color:'#aab',
            textDecoration:'none',
            fontSize:'14px',
            fontWeight:500
          }}>
            {item}
          </Link>
        ))}

        <Link href="/admin" style={{
          background:'#f5a623',
          color:'#000',
          padding:'8px 20px',
          borderRadius:'6px',
          textDecoration:'none',
          fontSize:'14px',
          fontWeight:700
        }}>
          Acceso Empresa
        </Link>
      </div>
    </nav>
  );
}
